import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { ProductLanguageSellPageVo } from './types';

/**
 * 根据路由获取sell详情
 */
export const getSeoSellPageInfo = (query: { routeUrl: string }): AxiosPromise<ProductLanguageSellPageVo> => {
  return request({
    url: '/product/api/seo/sellPageInfo',
    method: 'get',
    params: query
  });
};
